/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    StatsActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchSocialStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_SOCIAL && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, StatsActions.receiveSocialStats))
);

export const fetchSocialPostStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_SOCIAL_POSTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, StatsActions.receiveSocialPostStats))
);

export const fetchRouteStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_ROUTE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, StatsActions.receiveRouteStats))
);

export const fetchRoutePostStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_ROUTE_POSTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, StatsActions.receiveRoutePostStats))
);

export const fetchAllStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_ALL && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, StatsActions.receiveAllStats))
);

export const fetchAllPostStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_ALL_POSTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, StatsActions.receiveAllPostStats))
);

export const fetchGeoStatsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.STATS_FETCH_GEO && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, StatsActions.receiveAllGeoStats))
);
